<template>
  <div class="success-content">
    <font-awesome-icon class="success-icon" :icon="'thumbs-up'" />
    <h1 class="success-title">Seu pagamento foi concluído com sucesso!</h1>

    <p class="success-text">
      Acesse a Área do Cliente em nosso site
      <a target="_blank" href="https://valesaudepet.com.br" title="Vale Saúde Pet"
        >valesaudepet.com.br</a
      >.
      <br />
      Clique em PRIMEIRO ACESSO e digite seu e-mail cadastrado.<br />
      Você receberá um e-mail para definir sua senha
    </p>

    <!-- Retornar botões assim que tivermos o app publicado -->
    <p class="success-buttons" v-if="false">
      <!-- TODO: Alterar URL do app para Vale Saúde Pet -->
      <a href="https://apps.apple.com/br/app/vale-sa%C3%BAde-sempre/id1473828335" target="black">
        <img
          src="../../../public/img/download/apple-store.png"
          alt="vale saude pet app"
          title="app da vale saude pet"
        />
      </a>
      <!-- TODO: Alterar URL do app para Vale Saúde Pet -->
      <a
        href="https://play.google.com/store/apps/details?id=cliente.valesaudesempre.com.br&hl=pt_BR"
        target="black"
      >
        <img
          src="../../../public/img/download/google-app.png"
          alt="vale saude pet app"
          title="app da vale saude pet"
        />
      </a>
    </p>

    <p class="success-text">
      <strong>Para cadastrar seus pets, acesse a Área do Cliente.</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SuccessDefault',
  data() {
    return {
      message: sessionStorage.getItem('paid')
    };
  }
};
</script>

<style lang="scss">
.success {
  text-align: center;
  color: var(--color-positive-normal);

  &-title {
    font-size: 24px;
    text-transform: uppercase;
  }

  &-icon {
    margin: 32px;
    font-size: 104px;
    color: var(--color-balanced);
  }

  &-text {
    font-size: 18px;

    a {
      color: var(--color-positive-normal);
    }
  }

  &-buttons {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 32px;

    img {
      width: 160px;
    }
  }
}

.error {
  color: var(--color-assertive-normal);

  &-icon {
    color: var(--color-assertive);
    margin: 32px;
    font-size: 104px;
  }
}
</style>
